module.exports = __webpack_public_path__ + "static/media/beep_high.ca4f78d9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/beep_high.mp3
// module id = 24
// module chunks = 0